import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextInput from '../../../shared/inputs/TextInput';
import { searchAction } from '../actions/tableEditor';

export default function Search(props) {
  const { options } = props;
  const dispatch = useDispatch();
  const { dataOptions } = useSelector((state) => state.projectConfig);
  const { searchValue } = useSelector((state) => state.tableEditorPage);

  const changeAndSearch = (e) => dispatch(searchAction({ query: e.target.value, dataOptions }));

  const iconStyle = {
    color: options?.style?.borderColor ?? ''
  };

  return (
    <div className="search-field-container">
      <i className="fas fa-magnifying-glass absolute z-[1] top-[14px] left-[17px]" style={iconStyle} />
      <TextInput
        name="search-tables"
        value={searchValue || ''}
        onChange={changeAndSearch}
        placeholder={options.placeholderText || 'Search in table'}
        inputClassName={'inline-component pl-6'}
        style={options?.style ?? {}}
      />
    </div>
  );
}
